import * as Config from '../../../config';
import React from 'react';
import { connect, useSelector } from "react-redux";
import PropTypes from 'prop-types';
import './Cart.css';

import ListV2 from '../content/list/ListV2';
import Content from '../common/Content';
import Spinner from '../common/Spinner';
import ButtonCheckout from './ButtonCheckout';
import ButtonSettings from './ButtonSettings';
import useGetOne from '../../../hooks/useGetOne';
import usePageScroll from '../../../hooks/usePageScroll';
// import ButtonEditor from '../touch/ButtonEditor';
// import ButtonsCartEdit from './ButtonsCartEdit';
import CartPlaylistInfo from './CartPlaylistInfo';
import RecommendationFromList from '../recommendation/RecommendationFromList';

function ConnectedCartPlaylist({
  api, dimension, refresh = null, touchEditor
}) {
  const { item } = useGetOne(api, '/v4/my/default-cart/'); //useGetOne(api, '/v4/my/default-cart/', refresh);
  const { width, height } = dimension;
  const customFormatData = (data) => data.map(Config.formattedFromCart);
  const isFull = (item && item.tracks.length >= Config.MAX_CART_ITEMS);
  let { onScroll } = usePageScroll();

  const cartCounter = useSelector(state => state.cartCounter);
  const refreshKey = (cartCounter && item) ? cartCounter : 0;

  return (!item)
    ? <Spinner />
    : (
      <div className={`release-page global-page`} style={{ height }} onScroll={onScroll}>
        <Content name={`Cart`} isSticky={true} showTitle={false}
          scrollIntoView={false}
          stickyClassName={`global-sticky-menu`}
          contentClassName={`content-cart`}
          styleHeader={{width: width + (Config.CONTENT_PAD * 2), height: 70, top: 5}}
          subContent={(
            <div className={`flexRow card-container-cart`}>
              <div className={`playlist-infos infos-cart flexRow space-between`}>
                <div className={'flexColumn f-center'}>
                  <p className={`playlist-title type-title`} style={{size: 24}}>Cart</p>
                  <div className={`playlist-p type-small flexColumn`}>
                    <div className={'flexRow'} style={{height: 16, gap: 4, color: '#8C8C8C'}}>
                      <CartPlaylistInfo />
                      {/* <span> • <a className='link-enable' target={'blank'} href={`https://www.${Config.APP_NAME}.com/account/carts`}>Cart settings</a></span> */}
                    </div>          
                    {/* <span className={'type-placeholder'}>Tracks are added to your default cart. To change it, visit cart preferences on {Config.capAppName()}.com.</span> */}
                  </div>
                </div>
                <div className={'flexColumn'}>
                  {(item && item.tracks.length > 0) && (
                    <div className={'flexRow space-between playlist-actions-container'}>
                      {/* {touchEditor && <ButtonsCartEdit /> } */}
                      {/* <ButtonEditor label={`Edit`} /> */}
                      { !touchEditor && <ButtonSettings /> }
                      { !touchEditor && <ButtonCheckout id={item.id} /> }
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        >

          {  (item && item.tracks.length > 0) ? ( 
            <>
              <ListV2
                key={`listv2-cart-${refreshKey}`}
                id={`Cart`}
                pathApi={'/v4/my/default-cart/items/?per_page=100'}
                customFormatData={customFormatData}
                sortable={false}
                width={width}
                height={ ((Config.LIST_ROW_HEIGHT + Config.LIST_ROW_GAP) * item.tracks.length) + 4 }
                size={Config.LIST_ROW_HEIGHT}
                style={{ marginTop: 115 }}
                filtersStyle={{ display: `none`, top: 0, right: 0 }}
                panelStyle={{}}
                filters={[]}
                type={`Cart`}
                enableKeys={true}
                enableShortcuts={true}
                orderBy={[]}
                isBoost={true}
                automix={false}
                isLoadMore={true}
                from={'/cart'}
                cache={false}
              />
              {isFull 
                ? (
                  <div style={{marginTop: 16}}>
                    <span className={'type-black-5'} >DJ App Cart limit is {Config.MAX_CART_ITEMS}, please remove track(s) or checkout.</span>
                  </div>
                )
                : null
              }
              { Config.MOD_RECOMMENDATION && <RecommendationFromList listID={`Cart`} from={'/cart'} width={width} /> }
            </>
            ) : ((item && item.tracks.length === 0)
              ? <span className={'type-placeholder'} style={{marginTop: 120, position: 'absolute'}}>Tracks selected for purchase using add to cart will appear here, ready for checkout.</span>
              : null
          ) }

        </Content>
      </div>
    )
}

ConnectedCartPlaylist.propTypes = {
  refresh: PropTypes.any, 
  style: PropTypes.object
}

const CartPlaylist = connect(
  state => ({
    api: state.api,
    dimension: state.dimension,
    touchEditor: state.touchEditor,
    refresh: state.cartCounter
  })
)(ConnectedCartPlaylist);

export default CartPlaylist;
